export default function toPercentage(value: number) {
  return value ? `${(value * 100).toFixed(2)}%` : '';
}
